var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyideabulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.62C16.5 11.2 15.23 13.185 13.298 14.492C12.848 14.796 12.623 14.948 12.512 15.122C12.402 15.294 12.363 15.522 12.288 15.976L12.228 16.329C12.096 17.127 12.029 17.526 11.749 17.763C11.469 18 11.065 18 10.256 18H7.644C6.835 18 6.431 18 6.151 17.763C5.871 17.526 5.805 17.127 5.671 16.329L5.613 15.976C5.537 15.523 5.5 15.296 5.39 15.124C5.28 14.952 5.054 14.798 4.603 14.49C2.692 13.183 1.5 11.199 1.5 8.62C1.5 4.413 4.858 1 9 1C9.50387 0.999471 10.0065 1.0504 10.5 1.152",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.803 8.49831C15.889 8.16031 13 7 13 7L8 8.5L11 4L10.5 1.5M11 17.9983V18.9983C11 19.9413 11 20.4123 10.707 20.7053C10.414 20.9983 9.943 20.9983 9 20.9983C8.057 20.9983 7.586 20.9983 7.293 20.7053C7 20.4123 7 19.9413 7 18.9983V17.9983",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyideabulb);
export default __webpack_public_path__ + "static/media/emptyideabulb.067a4547ab9bd0dc5ded706a5f7cd078.svg";
export { ForwardRef as ReactComponent };